<template>
    <AddGoogleReview
        v-show="chooseReviewsStep"
        @stepBack="handlePlaceChosen({ place_id: '', name: '' })"
        @addSelected="handleAddSelectedReviews($event)"
        :place="place"
    />
    <SearchGooglePlace
        v-show="!chooseReviewsStep"
        @chosePlace="handlePlaceChosen($event)"
        @placeIdProvided="handleIdProvided($event)"
    />
</template>

<script>
import AddGoogleReview from "./google-reviews/AddGoogleReview.vue";
import SearchGooglePlace from "./google-reviews/SearchGooglePlace.vue";
import { mapMutations, mapState, mapActions } from "vuex";
import { LOVE_PREVIEW_KIND, LOVE_ROUTE_NAMES } from "@/apps/love/love.routes";

export default {
    components: {
        AddGoogleReview,
        SearchGooglePlace,
    },
    data() {
        return {
            place: {
                id: "",
                name: "",
            },
        };
    },
    computed: {
        ...mapState("love", ["wall"]),
        chooseReviewsStep() {
            return Boolean(this.place.id);
        },
    },
    methods: {
        ...mapActions("love/projects", ["saveSnapshot"]),
        ...mapMutations("love", ["addTestimonial"]),
        routeTo(name, forcedView) {
            const { query } = this.$route;
            this.$router.push({ name, query: forcedView ? { ...query, view: forcedView } : query });
        },
        handlePlaceChosen({ place_id, name }) {
            this.place = { id: place_id, name };
        },
        handleIdProvided(placeId) {
            this.place = { id: placeId, name: placeId };
        },
        async handleAddSelectedReviews(reviews) {
            for (const r of reviews) {
                this.addTestimonial({ ...r, isPublished: this.wall.publishAutomatically });
            }
            await this.saveSnapshot();
            this.routeTo(LOVE_ROUTE_NAMES.projectReviewsList, LOVE_PREVIEW_KIND.wall);
            // stepBack:
            // this.handlePlaceChosen({ place_id: "", name: "" });
        },
    },
};
</script>
